//Built-in libraries

//Third party libraries
import { PatternFormat as NumberFormat } from 'react-number-format';
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';

//Services
import { accountingFormatNumber, formatDate3, formatNumber } from '@/utils';
//Custom components
import ReviewCard from './ReviewCard';

//STP Libraries

import { Accordion, AccordionItem } from '@/components/UI/Accordion';
//Assets and Miscellaneous
import { boardOfDirectorsMapping } from '../LeadershipInformation/constant';

//Component Begin

export default function Review() {
  const { setCurrentStep, data } = useApplicationFormContext();
  const { projectDetails, developmentTeam, developmentSchedule, projectFinance, applicantInfo, leadershipInformation, experience } = data;

  return (
    <div className={'space-y-5 px-6 py-4 lg:col-span-9'}>
      <ReviewCard title='Project Details' handleEdit={() => setCurrentStep(1)}>
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Street Address</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.streetAddress}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>City</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.city}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>State</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.state}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Zip/Postal Code</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.zipCode}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Neighborhood</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.neighborhood}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Proposed Project Type</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.projectType}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>No. of Commercials Sq. Ft</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {projectDetails?.noOfCommercial ? projectDetails?.noOfCommercial : 'None'}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Proposed Number of Units</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {formatNumber(projectDetails.proposedUnits ? projectDetails.proposedUnits : 0)}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Is Proposed Project "By Right"</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.projectByRight}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Proposed Construction Type</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.constructionType}</dd>
          </div>
          {/* <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Proposed Purchase Price
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: projectDetails.proposedPurchasePrice
                  ? projectDetails.proposedPurchasePrice
                  : 0,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div> */}
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Estimated Development Cost</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: projectDetails.developmentCostEstimate ? projectDetails.developmentCostEstimate : 0,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Proposed Acquisition Type</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.acquisitionType}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Proposed Status Of Site Control</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.siteControlStatus}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Do you have community support?</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>{projectDetails.haveCommunitySupport}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Is the property city owned?</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {projectDetails.isPropertyCityOwn === 'yes' ? 'Yes' : 'No'}
            </dd>
          </div>
          {projectDetails.isPropertyCityOwn === 'yes' && (
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>How much are you proposing to pay for the property?</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                {accountingFormatNumber({
                  num: projectDetails.proposedAmount ? projectDetails.proposedAmount : 0,
                  format: 'en-US',
                  currency: 'USD',
                })}
              </dd>
            </div>
          )}
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Is this a Single-family or Multi-Family project?</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>{projectDetails.familyType}</dd>
          </div>
          {projectDetails.familyType === 'single' && (
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>What will be the average sales price?</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>
                {accountingFormatNumber({
                  num: projectDetails.avgSalesPrice ? projectDetails.avgSalesPrice : 0,
                  format: 'en-US',
                  currency: 'USD',
                })}
              </dd>
            </div>
          )}
          {projectDetails.familyType === 'multi' && (
            <>
              <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Studios</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>
                  {accountingFormatNumber({
                    num: projectDetails.rentType.studios ? projectDetails.rentType.studios : 0,
                    format: 'en-US',
                    currency: 'USD',
                  })}
                </dd>
              </div>
              <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>One Bedroom</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>
                  {accountingFormatNumber({
                    num: projectDetails.rentType.oneBedroom ? projectDetails.rentType.oneBedroom : 0,
                    format: 'en-US',
                    currency: 'USD',
                  })}
                </dd>
              </div>
              <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Two Bedrooms</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>
                  {accountingFormatNumber({
                    num: projectDetails.rentType.twoBedrooms ? projectDetails.rentType.twoBedrooms : 0,
                    format: 'en-US',
                    currency: 'USD',
                  })}
                </dd>
              </div>
              <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500'>Three Bedrooms</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>
                  {accountingFormatNumber({
                    num: projectDetails.rentType.threeBedrooms ? projectDetails.rentType.threeBedrooms : 0,
                    format: 'en-US',
                    currency: 'USD',
                  })}
                </dd>
              </div>
            </>
          )}
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>More Information</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectDetails.moreInfo}</dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard title='Development Team' handleEdit={() => setCurrentStep(2)}>
        {developmentTeam.length > 0 && (
          <dl>
            {developmentTeam.map((dt: any, i: number) => (
              <div key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-50'} px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6`}>
                <dt className='text-sm font-medium text-gray-500'>{dt.role}</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{dt.companyName}</dd>
              </div>
            ))}
          </dl>
        )}
        {developmentTeam.length === 0 && <div className='p-6 bg-white'>None</div>}
      </ReviewCard>
      <ReviewCard title='Development Schedule' handleEdit={() => setCurrentStep(3)}>
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Acquisition</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 space-x-4'>
              <span>
                Start Date:{' '}
                {developmentSchedule?.schedule1?.startDate ? formatDate3(developmentSchedule.schedule1.startDate.toDateString()) : 'None'}
              </span>
              <span>
                Finish Date:{' '}
                {developmentSchedule?.schedule1?.finishDate ? formatDate3(developmentSchedule.schedule1.finishDate.toDateString()) : 'None'}
              </span>
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Financial Close</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 space-x-4'>
              <span>
                Start Date:{' '}
                {developmentSchedule?.schedule2?.startDate ? formatDate3(developmentSchedule.schedule2.startDate.toDateString()) : 'None'}
              </span>
              <span>
                Finish Date:{' '}
                {developmentSchedule?.schedule2?.finishDate ? formatDate3(developmentSchedule.schedule2.finishDate.toDateString()) : 'None'}
              </span>
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Construction</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 space-x-4'>
              <span>
                Start Date:{' '}
                {developmentSchedule?.schedule3?.startDate ? formatDate3(developmentSchedule.schedule3.startDate.toDateString()) : 'None'}
              </span>
              <span>
                Finish Date:{' '}
                {developmentSchedule?.schedule3?.finishDate ? formatDate3(developmentSchedule.schedule3.finishDate.toDateString()) : 'None'}
              </span>
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Lease Up</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 space-x-4'>
              <span>
                Start Date:{' '}
                {developmentSchedule?.schedule4?.startDate ? formatDate3(developmentSchedule.schedule4.startDate.toDateString()) : 'None'}
              </span>
              <span>
                Finish Date:{' '}
                {developmentSchedule?.schedule4?.finishDate ? formatDate3(developmentSchedule.schedule4.finishDate.toDateString()) : 'None'}
              </span>
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Exit</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 space-x-4'>
              <span>
                Start Date:{' '}
                {developmentSchedule?.schedule5?.startDate ? formatDate3(developmentSchedule.schedule5.startDate.toDateString()) : 'None'}
              </span>
              <span>
                Finish Date:{' '}
                {developmentSchedule?.schedule5?.finishDate ? formatDate3(developmentSchedule.schedule5.finishDate.toDateString()) : 'None'}
              </span>
            </dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard title='Project Financial' handleEdit={() => setCurrentStep(4)}>
        <dl>
          <h2 className='px-6 text-sm font-bold text-gray-500'>Sources</h2>
          {projectFinance.sources.map((source: any, index: number) => {
            return (
              <div key={index} className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                <dt className='text-sm font-medium text-gray-500 capitalize'>{source.name}</dt>
                <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                  {accountingFormatNumber({
                    num: source.amount,
                    format: 'en-US',
                    currency: 'USD',
                  })}
                </dd>
              </div>
            );
          })}
          <h2 className='px-6 text-sm font-bold text-gray-500'>Uses</h2>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Acquisition</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: projectFinance.uses.acquisition,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Hard Cost</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: projectFinance.uses.hardCost,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Soft Cost</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: projectFinance.uses.softCost,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Finance Cost</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: projectFinance.uses.financeCost,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Developer Fee</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {accountingFormatNumber({
                num: projectFinance.uses.developerFeeAmount,
                format: 'en-US',
                currency: 'USD',
              })}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Will you be using HOME funds (www.home.com)?</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>{projectFinance.willUseHomeFunds}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Will you be using CDBG funds(www.cdbg.com)?</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 capitalize'>{projectFinance.willUseCDBGFunds}</dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard title='Company Information' handleEdit={() => setCurrentStep(5)}>
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Entity Name</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{applicantInfo.entityName}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Contact Person Name</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{applicantInfo.contactPersonName}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Contact Person E-mail</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{applicantInfo.contactPersonEmail}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Phone Number</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              <NumberFormat value={applicantInfo.phone} format='+1 (###) ###-####' displayType={'text'} />
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Street Address</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{applicantInfo.streetAddress}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>City</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{applicantInfo.city}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>State</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{applicantInfo.state}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Zip / Postal Code</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{applicantInfo.zipCode}</dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Website</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{applicantInfo.website ?? 'None'}</dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Formation Date</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {formatDate3(new Date(applicantInfo.formationDate).toDateString())}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Number of Full Time Employees</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {formatNumber(applicantInfo.fullTimeEmployeeCount ? applicantInfo.fullTimeEmployeeCount : 0)}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Following Apply</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {applicantInfo.anyApply.map((any: string) => (
                <span key={any}>{any}, </span>
              ))}
            </dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard title='Leadership Information' handleEdit={() => setCurrentStep(6)}>
        <dl>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              What racial/ethnic groups does the highest authority member of management (President, CEO, Partner, etc) belong to?
            </dt>

            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {leadershipInformation.racialEthnicGroup.map((group: string) => (
                <span key={group}>{group}, </span>
              ))}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Is the majority ownership (51% or greater) of the company held by someone that is considered disadvantaged?
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {leadershipInformation.majorityOwnership.length > 0
                ? leadershipInformation.majorityOwnership.map((major: string) => <span key={major}>{major}, </span>)
                : 'None'}
            </dd>
          </div>
          <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Company is governed by a board of directors</dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {Object.keys(leadershipInformation.boardOfDirectorsPercent)
                ?.filter((key) => !!leadershipInformation.boardOfDirectorsPercent[key])
                ?.map((key) => {
                  return (
                    <span key={key}>
                      {boardOfDirectorsMapping[key]}({leadershipInformation.boardOfDirectorsPercent[key]}
                      %),{' '}
                    </span>
                  );
                })}
            </dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard title='Experience' handleEdit={() => setCurrentStep(7)}>
        <div>
          <h2 className='px-6 text-sm font-bold text-gray-500'>Company Completed Recent Projects</h2>
          {experience.companyCompleted.length > 0 && (
            <Accordion multi>
              <div className='px-6 space-y-4'>
                {experience.companyCompleted.map((project: any) => (
                  <div key={project.id} id={project.id} className='bg-white'>
                    <AccordionItem
                      id={project.id}
                      title={
                        <>
                          <p className='font-bold'>{project.projectName}</p>
                          <span className='text-neutralColor-normal'>
                            {project.streetAddress}, {project.city},{project.state},{project.zipCode}
                          </span>
                        </>
                      }
                    >
                      <dl className='grid grid-cols-12'>
                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Date Completed</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {formatDate3(new Date(project.dateCompleted).toDateString())}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Gross Building Area</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {formatNumber(project.grossBuildingArea ? project.grossBuildingArea : 0)} Sq.Ft
                          </dd>
                        </div>
                        <div className='col-span-6 bg-white-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Number of Housing Units</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {formatNumber(project.housingUnits ? project.housingUnits : 0)}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-white py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Total Development Cost</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {accountingFormatNumber({
                              num: project.developmentCost ? project.developmentCost : 0,
                              format: 'en-US',
                              currency: 'USD',
                            })}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Project Type</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {project.projectTypes.length > 0 &&
                              project.projectTypes.map((type: string) => <span key={type}>{type}, </span>)}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Construction Type</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {project.constructionTypes.length > 0 &&
                              project.constructionTypes.map((type: string) => <span key={type}>{type}, </span>)}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-white py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Company's Role</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {project.companyRole?.map((role: string) => (
                              <span key={role}>{role}, </span>
                            ))}
                            {project.partialOwner && (
                              <span>
                                Partial Owner ({project.partialOwner}
                                %)
                              </span>
                            )}
                          </dd>
                        </div>
                      </dl>
                    </AccordionItem>
                  </div>
                ))}
              </div>
            </Accordion>
          )}
          {experience.companyCompleted.length === 0 && <div className='px-6'>None</div>}
        </div>
        <div>
          <h2 className='px-6 text-sm font-bold text-gray-500'>Principal Completed Recent Projects</h2>
          {experience.principalCompleted.length > 0 && (
            <Accordion multi>
              <div className='px-6 space-y-4'>
                {experience.principalCompleted.map((project: any) => (
                  <div key={project.id} id={project.id} className='bg-white'>
                    <AccordionItem
                      id={project.id}
                      title={
                        <>
                          <p className='font-bold'>{project.projectName}</p>
                          <span className='text-neutralColor-normal'>
                            {project.streetAddress}, {project.city},{project.state},{project.zipCode}
                          </span>
                        </>
                      }
                    >
                      <dl className='grid grid-cols-12'>
                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Company Name</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{project.companyName}</dd>
                        </div>

                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Date Completed</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {formatDate3(new Date(project.dateCompleted).toDateString())}
                          </dd>
                        </div>

                        <div className='col-span-6 bg-white-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Gross Building Area</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {formatNumber(project.grossBuildingArea ? project.grossBuildingArea : 0)} Sq.Ft
                          </dd>
                        </div>
                        <div className='col-span-6 bg-white py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Number of Housing Units</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {formatNumber(project.housingUnits ? project.housingUnits : 0)}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Development Cost</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {accountingFormatNumber({
                              num: project.developmentCost ? project.developmentCost : 0,
                              format: 'en-US',
                              currency: 'USD',
                            })}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-gray-50 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Project Types</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {project.projectTypes.length > 0 &&
                              project.projectTypes.map((type: string) => <span key={type}>{type}, </span>)}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-white py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Construction Type</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {project.constructionTypes.length > 0 &&
                              project.constructionTypes.map((type: string) => <span key={type}>{type}, </span>)}
                          </dd>
                        </div>
                        <div className='col-span-6 bg-white py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
                          <dt className='text-sm font-medium text-gray-500'>Company's Role</dt>
                          <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
                            {project.companyRole?.map((role: string) => (
                              <span key={role}>{role}, </span>
                            ))}
                            {project.partialOwner && (
                              <span>
                                Partial Owner ({project.partialOwner}
                                %)
                              </span>
                            )}
                          </dd>
                        </div>
                      </dl>
                    </AccordionItem>
                  </div>
                ))}
              </div>
            </Accordion>
          )}
          {experience.principalCompleted.length === 0 && <div className='px-6 pb-4'>None</div>}
        </div>
      </ReviewCard>
    </div>
  );
}
